import { CollectionModel } from 'common/api/models';
import { callApi, sortingApiMap } from 'utils';
import { getI18nLng } from 'utils/i18n';

/**
 * @param {number} channelId
 * @param {number} pageNum
 * @param {string} sorting
 * @param {number} perPage
 * @param {boolean} featuredFirst
 * @return {Promise<any>}
 */
export const fetchCollectionApi = ({ channelId, pageNum, sorting, perPage, featuredFirst = false }) => {
  const language = getI18nLng();

  return callApi(
    `collection/${channelId}?pageNum=${pageNum}${sortingApiMap(sorting)}${
      perPage ? '&perPage=' + perPage : ''
    }&featuredFirst=${featuredFirst}&lang=${language}`
  ).then((collection) => CollectionModel(collection));
};
